var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { colorPalette } from '../../../colorPalette';
import Typography from '@mui/material/Typography';
import { buttonBaseClasses, svgIconClasses } from '@mui/material';
export const DrawerTabs = (_a) => {
    var { tabs, selectedTab, onChangeTab, sx } = _a, rest = __rest(_a, ["tabs", "selectedTab", "onChangeTab", "sx"]);
    const a11yProps = (index) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    };
    const handleChange = (_, newValue) => {
        if (onChangeTab) {
            onChangeTab(newValue);
        }
    };
    const renderTabPanel = ({ value, index, children }) => {
        if (value !== index) {
            return null;
        }
        return (React.createElement(Box, { key: value, component: "div", role: "tabpanel", hidden: selectedTab !== index, id: `simple-tabpanel-${index}`, "aria-labelledby": `simple-tab-${index}`, sx: {
                position: 'relative',
                height: '100%',
                overflow: 'auto',
            } },
            React.createElement(Box, { sx: {
                    height: '100%',
                    overflow: 'auto',
                    scrollbarWidth: 'none',
                    '-ms-overflow-style': 'none',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                } }, children)));
    };
    return (React.createElement(Stack, { sx: {
            maxHeight: {
                xs: '80vh',
                sm: '90vh',
            },
            overflow: 'hidden',
        } },
        React.createElement(Tabs, Object.assign({ component: "div", sx: Object.assign({ [`& .${buttonBaseClasses.root}`]: {
                    marginTop: '2px',
                }, [`& .${svgIconClasses.root}`]: {
                    height: '24px',
                    width: '24px',
                }, position: 'sticky', borderBottom: `1px solid ${colorPalette.gray200}` }, sx), "data-qa": "drawer-tab", value: selectedTab, onChange: handleChange, allowScrollButtonsMobile: true }, rest), tabs.map((tab, index) => (React.createElement(Tab, Object.assign({ key: index, disabled: tab.disabled, label: typeof tab.label === 'string' ? React.createElement(Typography, null, tab.label) : tab.label }, a11yProps(index)))))),
        React.createElement(Box, { sx: {
                flexGrow: 1,
                overflow: 'hidden',
            } }, tabs.map((tab) => renderTabPanel({ value: tab.value, index: selectedTab || 0, children: tab.children })))));
};
